import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'comments-confirm-dialog.delete-comment-heading': {
    id: 'comments-confirm-dialog.delete-comment-heading',
    defaultMessage: 'Do you want to delete this comment?',
    description: 'The header of the confirmation dialog for deleting a comment',
  },
  'comments-confirm-dialog.delete-comment-body': {
    id: 'comments-confirm-dialog.delete-comment-body',
    defaultMessage: 'Your comment will be permanently removed if you do.',
    description:
      'The message displayed inside the confirmation dialog for deleting a comment',
  },
  'comments-confirm-dialog.delete-comment-confirm-button': {
    id: 'comments-confirm-dialog.delete-comment-confirm-button',
    defaultMessage: 'Delete',
    description: 'The call to action that will confirm a comment should be deleted',
  },
  'comments-confirm-dialog.delete-comment-cancel-button': {
    id: 'comments-confirm-dialog.delete-comment-cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The button inside of the confirmation dialog for deleting a comment that will cancel the action',
  },
  'comments-snackbar.confirm-resolved-comment': {
    id: 'comments-snackbar.confirm-resolved-comment',
    defaultMessage: 'Comment resolved',
    description: 'The message displayed inside of a flag when a user resolves a comment',
  },
  'comments-snackbar.undo-resolved-comment': {
    id: 'comments-snackbar.undo-resolved-comment',
    defaultMessage: 'Undo',
    description:
      'The button at the end of the resolved comments snackbar message that lets users undo a resolved comment',
  },
  'whiteboards.comment-editor.cancel': {
    id: 'whiteboards.comment-editor.cancel',
    defaultMessage: 'Cancel',
    description: 'Label for the button that cancels editing a comment',
  },
  'whiteboards.comment-editor.save': {
    id: 'whiteboards.comment-editor.save',
    defaultMessage: 'Save',
    description: 'Label for the button that saves an edited comment',
  },
  'whiteboards.comment-editor.default-placeholder': {
    id: 'whiteboards.comment-editor.default-placeholder',
    defaultMessage: 'Type to comment or @ to mention',
    description: 'Default placeholder text for the comment editor',
  },
  'whiteboards.comment-editor.standardized-placeholder': {
    id: 'whiteboards.comment-editor.standardized-placeholder',
    defaultMessage: 'Add text, @mention others, or use / for elements',
    description:
      'The standardized placeholder for the comment editor, emphasizing different ways to interact with the editor',
  },
  'whiteboards.comment-editor.someone-is-typing': {
    id: 'whiteboards.comment-editor.someone-is-typing',
    defaultMessage:
      '{numUsers, plural, one {{user} is typing...} other {# others are typing...}}',
    description: 'Text stating that another user/users are typing',
  },
  'whiteboards.comment-thread-dialog.title': {
    id: 'whiteboards.comment-thread-dialog.title',
    defaultMessage: 'Comments',
    description:
      'Title/heading of a popup dialog displaying comments. The popup dialog shows comments that have been left on a whiteboard.',
  },
  'whiteboards.comment-thread-dialog.thread-navigation': {
    id: 'whiteboards.comment-thread-dialog.thread-navigation',
    defaultMessage: '{currentThreadNumber} of {numberOfThreads}',
    description:
      'A heading that shows you what number comment thread the user is viewing and how many there are.',
  },
  'whiteboards.comment-action.replies': {
    id: 'whiteboards.comment-action.replies',
    defaultMessage: '{numReplies, plural, one {# reply} other {# replies}}',
    description: 'Label for the button that shows the comments replies',
  },
  'whiteboards.comment-action.replies-tooltip': {
    id: 'whiteboards.comment-action.replies-tooltip',
    defaultMessage: 'View replies',
    description: 'Tooltip for the button that shows the comments replies',
  },
  'whiteboards.comment-action.resolve': {
    id: 'whiteboards.comment-action.resolve',
    defaultMessage: 'Resolve',
    description: 'Label for the button that resolves a comment',
  },
  'whiteboards.comment-action.resolve-comment-tooltip': {
    id: 'whiteboards.comment-action.resolve-comment-tooltip',
    defaultMessage: 'Resolve comment',
    description: 'Tooltip for the button that resolves a comment',
  },
  'whiteboards.comment-action.resolve-thread-tooltip': {
    id: 'whiteboards.comment-action.resolve-thread-tooltip',
    defaultMessage: 'Resolve thread',
    description: 'Tooltip for the button that resolves a thread',
  },
  'whiteboards.comment-action.edit': {
    id: 'whiteboards.comment-action.edit',
    defaultMessage: 'Edit',
    description: 'Label for the button that edits a comment',
  },
  'whiteboards.comment-action.edit-tooltip': {
    id: 'whiteboards.comment-action.edit-tooltip',
    defaultMessage: 'Edit comment',
    description: 'Tooltip for the button that edits a comment',
  },
  'whiteboards.comment-action.delete': {
    id: 'whiteboards.comment-action.delete',
    defaultMessage: 'Delete',
    description: 'Label for the button that deletes a comment',
  },
  'whiteboards.comment-action.delete-comment-tooltip': {
    id: 'whiteboards.comment-action.delete-comment-tooltip',
    defaultMessage: 'Delete comment',
    description: 'Tooltip for the button that deletes a comment',
  },
  'whiteboards.comment-action.delete-thread-tooltip': {
    id: 'whiteboards.comment-action.delete-thread-tooltip',
    defaultMessage: 'Delete thread',
    description: 'Tooltip for the button that deletes a thread',
  },
  'whiteboards.comment-action.copy-link-tooltip': {
    id: 'whiteboards.comment-action.copy-link-tooltip',
    defaultMessage: 'Copy link to comment',
    description: 'Tooltip for the button that copies a link',
  },
  'whiteboards.comment-action.link-copied-tooltip': {
    id: 'whiteboards.comment-action.link-copied-tooltip',
    defaultMessage: 'Copied!',
    description: 'Tooltip for the button that copies a link, when a link has been copied',
  },
  'comments-confirm-dialog.discard-comment-heading': {
    id: 'comments-confirm-dialog.discard-comment-heading',
    defaultMessage: 'Do you want to discard this comment?',
    description: 'The header of the confirmation dialog for discarding a comment draft',
  },
  'comments-confirm-dialog.discard-comment-body': {
    id: 'comments-confirm-dialog.discard-comment-body',
    defaultMessage: 'Your comment will be lost if you do.',
    description:
      'The message displayed inside the confirmation dialog for discarding a comment draft',
  },
  'comments-confirm-dialog.discard-comment-confirm-button': {
    id: 'comments-confirm-dialog.discard-comment-confirm-button',
    defaultMessage: 'Discard',
    description:
      'The call to action that will confirm a comment draft should be discarded',
  },
  'comments-confirm-dialog.discard-comment-cancel-button': {
    id: 'comments-confirm-dialog.discard-comment-cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The button inside of the confirmation dialog for discarding a comment draft that will cancel the action',
  },
});
